/**
 * The Rails CSRF token, for the handful of endpoints this app reaches with raw
 * `fetch()` rather than Inertia's router — the audience preview, Test Query,
 * and revealing a phone number on the run history. Inertia sets this header
 * itself; a bare fetch does not.
 *
 * The token comes from `csrf_meta_tags` in the layout. Returns an empty string
 * where there is no document at all, which is server-side rendering: nothing
 * that uses this runs there, and throwing would take the whole render down.
 */
export function csrfToken(): string {
  if (typeof document === "undefined") return ""

  return (
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
  )
}
